import { rest } from 'msw';
import { mockVouchers } from 'test-utils/mock-data/vouchers';
import { parseApiVoucher } from 'api-services/voucher-requests';

const backendUrl = process.env.BACKEND_API_URL || '';

export const voucherHandlers = [
  rest.get(`${backendUrl}/vouchers`, (req, res, ctx) => {
    const isValid = req.url.searchParams.get('isValid');
    return res(
      ctx.status(200),
      ctx.json(isValid
        ? mockVouchers.filter(product => product.isValid.toString() === isValid)
        : mockVouchers),
    );
  }),
  rest.get(`${backendUrl}/voucher/:code`, (req, res, ctx) => {
    const { code } = req.params;
    const voucher = mockVouchers.find(v => v.code === code);
    if (!voucher) return res(ctx.status(400));
    return res(
      ctx.status(200),
      ctx.json(voucher),
    );
  }),
  rest.post(`${backendUrl}/voucher`, (req, res, ctx) => {
    const voucher = parseApiVoucher(req.body);
    mockVouchers.push(voucher);
    return res(
      ctx.status(200),
      ctx.json(voucher),
    );
  }),
  rest.put(`${backendUrl}/voucher`, (req, res, ctx) => {
    const voucher = parseApiVoucher(req.body);
    const index = mockVouchers.findIndex(v => v.code === voucher.code);
    if (index === -1) mockVouchers.push(voucher);
    else mockVouchers[index] = voucher;
    return res(
      ctx.status(200),
      ctx.json(voucher),
    );
  }),
  rest.delete(`${backendUrl}/voucher/:code`, (req, res, ctx) => {
    const { code } = req.params;
    const voucherIndex = mockVouchers.findIndex(v => v.code === code);
    if (voucherIndex === -1) return res(ctx.status(400));
    const voucher = mockVouchers[voucherIndex];
    mockVouchers.splice(voucherIndex, 1);

    return res(
      ctx.status(200),
      ctx.json(voucher),
    );
  }),
];
